module.exports = __webpack_public_path__ + "static/img_pledge_interview_02-950e34bdd33420fd5fcdb75033000fee.png";